// extracted by mini-css-extract-plugin
module.exports = {"Headline":"Headline_Headline__2gYyT","headline":"Headline_headline__25Wyb"};